import * as types from "./actionTypes";
import * as dataListApi from "../../_api/dataListApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadStatesSuccess(states) {
  return { type: types.LOAD_STATES_SUCCESS, states };
}
export function loadStates(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return dataListApi
      .getStates(params)
      .then((states) => {
        dispatch(loadStatesSuccess(states));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadProgramTypesSuccess(programTypes) {
  return { type: types.LOAD_PROGRAM_TYPES_SUCCESS, programTypes };
}

export function loadProgramTypes(UserID, StateOfConviction) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return dataListApi
      .getProgramTypes(UserID, StateOfConviction)
      .then((programTypes) => {
        dispatch(loadProgramTypesSuccess(programTypes));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function getRegionId(searchObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return dataListApi
      .getRegionIdbyName(searchObj)
      .then((returnObj) => {
        const transformKeys = (obj) => {
          const newObj = {};
          for (const key in obj) {
            const newKey = key === "RegionId" ? "regionId" : key;
            newObj[newKey] = obj[key];
          }
          return newObj;
        };
        const transformedClient = transformKeys(returnObj);
        return transformedClient.regionId;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadRegions(regionId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return dataListApi
      .getRegionsByRegionId(regionId)
      .then((regions) => {
        if (regions.states.length > 0 && !(regions.states.length === 1 && regions.states[0].Name === null && regions.states[0].ShortName === null)) {
          let states = regions.states;
          states.sort((a, b) => -b.Name?.localeCompare(a.Name));
          return states;
        } else if (regions?.countries?.length > 0) {
          let countries = regions?.countries;
          const index = countries?.findIndex((x) => x.Description === "USA");
          if (index > -1) countries[index].Description = "United States";
          return countries;
        } else if (regions?.counties?.length > 0) {
          let counties = regions?.counties;
          counties?.sort((a, b) => -b?.Description?.localeCompare(a?.Description));
          return counties;
        } else {
          if (regions.RegionTypeId === 5) {
            //if country, return states, even if the array is empty
            return regions.states;
          }
          return regions;
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
